import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetSomeConciliacionUseCase } from "../../bussines/useCases/GetSomeConciliacionUseCase";
import { ConciliacionDtSourceImplRest } from "../../data/dataSources/ConciliacionDtSourceImplRest"
import { ConciliacionRepositoryImpl } from "../../data/repositories/ConcilacionRepositoryImpl";
import { GetSomeConciliacionParams } from "../../utils/params/GetSomeConciliacionParams";

export const useConciliacion = () => {
    const concilicacionDtSourceRest = new ConciliacionDtSourceImplRest();
    const repository = new ConciliacionRepositoryImpl(concilicacionDtSourceRest);

    const getSomeConciliacion = async (input: GetSomeConciliacionParams) => {
        const getSomeConciliacionUseCase = new GetSomeConciliacionUseCase(repository);
        const result = await executeUseCase({input, useCase: getSomeConciliacionUseCase});
        return result;
    };

    return {
        getSomeConciliacion
    }
}